// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2tsGh","productName":"Table_productName__28QZh"};